var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('Label',{attrs:{"item":_vm.item}}),_c('div',{staticClass:"flex col-12 mt-2"},_vm._l((_vm.item.options),function(option){return _c('div',{key:option,staticClass:"form-check col-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"form-check-input",style:(option == 'Red'
            ? 'accent-color: #b60000 !important'
            : option == 'Amber'
            ? 'accent-color: #a99518 !important'
            : option == 'Green'
            ? 'accent-color: #2a6528 !important'
            : ''),attrs:{"type":"radio","disabled":_vm.categoryName == 'globalupdate'
            ? false
            : _vm.selectedItem.additionalProp1.global
            ? true
            : false},domProps:{"value":option,"checked":_vm._q(_vm.value,option)},on:{"change":function($event){_vm.value=option}}}),_c('p',{staticClass:"alert-tag font-size-14",style:({
          backgroundColor: _vm.optiontoAlert[option].bgcolor,
          color: _vm.optiontoAlert[option].color,
        })},[_vm._v(" "+_vm._s(_vm.optiontoAlert[option].displayName)+" ")])])}),0),(_vm.submitted && _vm.validation.$error)?_c('div',{staticClass:"invalid-feedback"},[(!_vm.validation.required)?_c('span',[_vm._v("This value is required.")]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }